module.exports = __webpack_public_path__ + "img/Menu-06.e69229b7.png";